import { useEffect, useState } from "react"
import { downloadFile, RequestConfigs } from "../../api"
import { useFormHandling } from "../../hooks/formUtils"
import { CaseStatusBox, Col, DotListItem, ListItem, Row, StatusBox, Text, Toggle, VImage } from "../../style/base.style"
import { useDictionary } from "../../contexts/dictionary"
import { useContactType } from "../../contexts/ContactContext"
import { PopupLayout } from "../common/popup"
import { ActionButton, ButtonStyle } from "../buttons/ActionButton"
import { Colors } from "../../style/colors"
import { FormComponent } from "../form"
import { FieldType, TextFieldType } from "../fields"
import Joi from "joi"
import { Link } from "react-router-dom"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTicket } from '@fortawesome/free-solid-svg-icons'
import { is, tr } from "date-fns/locale"


interface CasesProps {
  minimize?:boolean
}

export const Cases = ({minimize}:CasesProps) => {

    
  const { handleClick, serverRes } = useFormHandling({ requestType: RequestConfigs.getCases })
  const {translate} = useDictionary()

  const [cases, setCases] = useState<Case[] | null>(null)

    const [openEditPopup,setEditOpenPopup] = useState<number>(-1)
    const [openNewPopup,setNewOpenPopup] = useState<boolean>(false)
    const [openCancelPopup,setCancelOpenPopup] = useState<number>(-1)

    const closeCancelPopup = (cases?:Case[]) => {
      if(cases && cases.length){
        setCases(cases)
      }

      setCancelOpenPopup(-1)

    }

    const closePopup = (caseData?:Case) => {
      if(caseData){
        setCases(prev => (
          prev ? [...prev, caseData] : [caseData]
        ))
      }
      setEditOpenPopup(-1)
      setNewOpenPopup(false)
    }

    const openEditPopupAction = (index:number) => {
      console.log('openPopupAction',index)
      setEditOpenPopup(index)
    }

       const openNewPopupAction = () => {

      setNewOpenPopup(true)
    }

    const openCancelPopupAction = (index:number) => {
      console.log('openPopupAction',index)
      setCancelOpenPopup(index)
    }


    useEffect(() => {
        handleClick()
    }, [])

    useEffect(() => {

        if (serverRes?.cases) {
          setCases(serverRes.cases)
        }
  }, [serverRes])


    return (
        <>
     {
      !minimize &&
        <Col $alignItems="flex-end" $width="100%">
        <ActionButton
        label={translate('new_case')}
        onClick={()=>openNewPopupAction()}
        />
       </Col>
     }
         <NewCasePopup isOpen={openNewPopup} onClose={closePopup} />
            <table className="table dashboard-table" style={{ borderSpacing: '0 5px',  borderCollapse: 'separate' }}>
                <tbody >
                    { cases &&
                        cases?.map((caseData, index) => {
                          if(minimize && index > 4){
                            return null
                          } else 
                           return (
                              <Row $margin="10px 0" $width="100%" $justifyContent="space-between" $alignItems="center" key={index} $padding="10px" $gap={10} style={{borderRadius: '10px',border: `1px solid ${Colors.fieldBorder}`}}>
                              <CancelCasePopup isOpen={openCancelPopup===index} onClose={closeCancelPopup} caseData={caseData}/>
                              <EditCasePopup isOpen={openEditPopup===index} onClose={closePopup} caseData={caseData}/>
                            
                          
                         
                              <Row className="right-sec" $width={minimize?"100%":"75%"} $justifyContent="flex-start" $alignItems="center" $gap={10} $backgroundColor="blue">
                              <Col $borderRadius={15} $padding="10px">
                              <FontAwesomeIcon icon={faTicket} style={{color:Colors.primary , fontSize:"24px"}}/>
                                {/* <VImage src={doctorIcon} $width={"30px"} $height={"30px"} /> */}
                              </Col>
                              
                               <Col $alignItems="flex-start" $width="80%">
                               
                                  <Text $margin="0" $fontWeight={600}>{translate(caseData.Case_Reason,"case_reason")}</Text>
                                  <Row $justifyContent="flex-start" $alignItems="center" $gap={10}>
                                    <Text $margin="0" $fontSize="13px" className="fa-solid fa-clock">{new Date(caseData.Created_Time).toLocaleString()}</Text>
                                    <CaseStatusBox $status={caseData.Status} >{translate(caseData.Status,"case_status")}</CaseStatusBox>

                                  </Row>
                                  
                                  <Row $width="100%" $justifyContent="flex-start" $alignItems="center" $gap={10}>
                                
                                  </Row>
                                  
                                  </Col>
                              </Row>
                            
                            {
                              !minimize && 
                              <Row $width="15%" $justifyContent="flex-end" $alignItems="center" $gap={10}>
   
                              { caseData.Status === "New" &&
                              <>
                               <Link
                                onClick={()=>openEditPopupAction(index)}
                                to="#"
                                className="edit-icon"
                             
                              >
                                  <i className="fa-solid fa-pen-to-square" />
                              </Link>

                               <Link
                                onClick={()=>openCancelPopupAction(index)}
                                to="#"
                                className="edit-icon"
                             
                              >
                               
                               <i className="fa-solid fa-trash" style={{color:Colors.error}}/>
                               </Link>
                                {/* <ActionButton style={ButtonStyle.light} width="100px" label={translate("edit")} onClick={()=>openPopupAction(index)} /> */}
                                {/* <ActionButton style={ButtonStyle.red} width="100px" label={translate("cancel")} onClick={()=>openPopupAction(index)} /> */}
                                
                              </>
                              
                              }
                              
                             
                            

                              </Row>
                       
                            }
                          
                            
                          </Row>
                          )
                        })
                    }
                    {
                        !cases?.length && 
                        <>
                        <Col $width="100%" $alignItems="center" $justifyContent="center" $padding="50px">
                            <h3>{translate('no_cases')}</h3>
                        </Col>
                        </>
                    }

                </tbody>
            </table>
        </>
    )
}




interface CasePopupProps {
  isOpen:boolean
  onClose:(cases?:Case[])=>void
  caseData:Case
}
interface EditCasePopupProps {
  isOpen:boolean
  onClose:(cases?:Case)=>void
  caseData:Case
}

const CancelCasePopup = ({isOpen,onClose,caseData}:CasePopupProps) => {
  const {handleClick,serverRes} = useFormHandling({requestType:RequestConfigs.cancelCase,data:{id:caseData.id}})
  const {contact} = useContactType()
  const {translate} = useDictionary()


 useEffect(() => {
    if(serverRes){
      if(serverRes.succeeded && serverRes.cases){
        onClose(serverRes.cases)
      }
    }
  
 }, [serverRes]);

  return (
    <PopupLayout isOpen={isOpen} onClose={onClose}>
      <Text>{translate('case_cancel_verify')}{" "}{caseData?.Subject}</Text>
      <Row $width='100%' $justifyContent='center' $gap={10}>
        <ActionButton style={ButtonStyle.light} width='100px' label={translate('cancel')} onClick={onClose} />
        <ActionButton style={ButtonStyle.dark} width='100px' label={translate('confirm')} onClick={handleClick} />
      </Row>
    </PopupLayout>
  )
}


const EditCasePopup = ({isOpen,onClose,caseData}:EditCasePopupProps) => {
  const {handleFormClick,serverRes,handleInputChange} = useFormHandling({requestType:RequestConfigs.updateCase,data:{id:caseData.id}})
  const attachmentsForm = useFormHandling({requestType:RequestConfigs.getCasesAttachments,urlParams:{caseId:caseData.id}})
  const {translate} = useDictionary()

  const [attachments,setAttachments] = useState<any[]>([])

  useEffect(() => {
   if(isOpen){
     attachmentsForm.handleClick()
   }
  },[isOpen])

  useEffect(() => {
    if(attachmentsForm.serverRes?.succeeded && attachmentsForm.serverRes?.attachments){
     const attachments = attachmentsForm.serverRes.attachments
     const mappedAttachments = attachments.map((attachment:Attachment) => ({
      name: attachment.File_Name,
      size: attachment.Size,
      url:`/contact/cases/${caseData.id}/download/${attachment.id}`
     }))
     setAttachments(mappedAttachments)

    }
  },[attachmentsForm.serverRes])

  const caseFields:FieldConfig[] = [
    {
      name:"Type",
      label:translate("type"),
      type:FieldType.select,
      joiSchema: Joi.string().required(),
      defaultValue:caseData?.Type,
      readonly:true,
      typeOptions:{
        options: [
          { label: "Claim", value: "Claim" },
          { label: "Problem", value: "Problem" },
          { label: "Question", value: "Question" },
       
        ]
      },

    },
    {
      name:"Case_Reason",
      label:translate("case_reason"),
      type:FieldType.select,
      joiSchema: Joi.string().required(),
      defaultValue:caseData?.Case_Reason,
      readonly:true,
      typeOptions:{
        options: [
          { label: "Other Request / Issue", value: "Other Request / Issue" },
          { label: "Refund Claim", value: "Refund Claim" },
          { label: "Doctor Home Visit Request", value: "Doctor Home Visit Request" },
       
        ]
      },

    },
    {
      name:"Subject",
      label:translate("subject"),
      type:FieldType.text,
      joiSchema: Joi.string().required(),
      defaultValue:caseData?.Subject,
      readonly:true,
      typeOptions:{
        type: TextFieldType.text
      },

    },
    {
      name:"Description",
      label:translate("description"),
      type:FieldType.text,
      joiSchema: Joi.string().required(),
      defaultValue:caseData?.Description,
      typeOptions:{
        type: TextFieldType.textArea
      },
    },
    {
      type: FieldType.upload,
      name: "upload",
      label: "upload",
      joiSchema: Joi.any(),
      defaultValue:attachments,
      typeOptions:{
        download:(url:string,fileName:string)=>{
          downloadFile(url,fileName)
          console.log('download',url)
        }
      }
  },
  

  ]

 useEffect(() => {
    if(serverRes){
      if(serverRes.succeeded && serverRes.case){
        onClose(serverRes.case)
      }
    }
  
 }, [serverRes]);



  return (
    <PopupLayout isOpen={isOpen} onClose={onClose}>
      <Col $width="400px">
      <FormComponent
      fields={caseFields}
      onChange={handleInputChange}
      />
      <ActionButton
      label="save"
      onClick={handleFormClick}
      />
      
      </Col>
     
    </PopupLayout>
  )
}

interface CreateCasePopupProps {
  isOpen:boolean
  onClose:(caseData?:Case)=>void

}


export const NewCasePopup = ({isOpen,onClose}:CreateCasePopupProps) => {
  const {handleFormClick,serverRes,handleInputChange} = useFormHandling({requestType:RequestConfigs.createCase})
  
  const {translate} = useDictionary()

  
  const caseFields:FieldConfig[] = [
    {
      name:"Type",
      label:translate("field","case_type"),
      type:FieldType.select,
      joiSchema: Joi.string().required(),
     
      typeOptions:{
        options: [
          { label:translate("Claim","case_type"), value: "Claim" },
          { label: translate("Problem","case_type"), value: "Problem" },
          { label: translate("Question","case_type"), value: "Question" },
       
        ]
      },

    },
    {
      name:"Case_Reason",
      label:translate("field","case_reason"),
      type:FieldType.select,
      joiSchema: Joi.string().required(),
     
      typeOptions:{
        options: [
          { label:translate("Other Request / Issue","case_reason") , value: "Other Request / Issue" },
          { label:translate("Refund Claim","case_reason") , value: "Refund Claim" },
          { label:translate("Doctor Home Visit Request","case_reason") , value: "Doctor Home Visit Request" },
       
        ]
      },

    },
    {
      name:"Description",
      label:translate("description"),
      type:FieldType.text,
      joiSchema: Joi.string().required(),
      typeOptions:{
        type: TextFieldType.textArea
      },
    },
    {
      type: FieldType.upload,
      name: "upload",
      label: "upload",
      joiSchema: Joi.any(),
      typeOptions:{
        download:(url:string,fileName:string)=>{
          downloadFile(url,fileName)
          console.log('download',url)
        }
      }
  },
  

  ]

 useEffect(() => {
    if(serverRes){
      console.log('serverRes',serverRes.succeeded , serverRes.case)
      if(serverRes.succeeded && serverRes.case){
        onClose(serverRes.case)
      }
    }
  
 }, [serverRes]);

 

  return (
    <PopupLayout isOpen={isOpen} onClose={onClose}>
      <Col $width="400px">
      <FormComponent
      fields={caseFields}
      onChange={handleInputChange}
      />
      <ActionButton
      label="save"
      onClick={handleFormClick}
      />
      
      </Col>
     
    </PopupLayout>
  )
}


